import { SVGInterface } from "../../interface";

const VolumeOff = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M4.34018 2.93506L2.93018 4.34506L7.29018 8.70506L7.00018 9.00506H3.00018V15.0051H7.00018L12.0002 20.0051V13.4151L16.1802 17.5951C15.5302 18.0851 14.8002 18.4751 14.0002 18.7051V20.7651C15.3402 20.4651 16.5702 19.8451 17.6102 19.0151L19.6602 21.0651L21.0702 19.6551L4.34018 2.93506ZM10.0002 15.1751L7.83018 13.0051H5.00018V11.0051H7.83018L8.71018 10.1251L10.0002 11.4151V15.1751ZM19.0002 12.0051C19.0002 12.8251 18.8502 13.6151 18.5902 14.3451L20.1202 15.8751C20.6802 14.7051 21.0002 13.3951 21.0002 12.0051C21.0002 7.72506 18.0102 4.14506 14.0002 3.23506V5.29506C16.8902 6.15506 19.0002 8.83506 19.0002 12.0051ZM12.0002 4.00506L10.1202 5.88506L12.0002 7.76506V4.00506ZM16.5002 12.0051C16.5002 10.2351 15.4802 8.71506 14.0002 7.97506V9.76506L16.4802 12.2451C16.4902 12.1651 16.5002 12.0851 16.5002 12.0051Z"
      fill={color || "#0E171F"}
    />
  </svg>
);
export default VolumeOff;
